import React, { useEffect, useState } from 'react';
import SEO from '../components/SEO';
import Navigation from '../components/Navigation';
import CurationCard from '../components/CurationCard';
import CurationCardSkeleton from '../components/CurationCardSkeleton';
import Footer from '../components/Footer';
import { getCachedCurations, refreshCurations } from '../services/contentService';
import { SITE_URL } from '../config/site';

export default function HomePage() {
  const [curations, setCurations] = useState(getCachedCurations);
  const [loading, setLoading] = useState(curations.length === 0);

  useEffect(() => {
    let active = true;
    refreshCurations().then((items) => {
      if (!active) return;
      if (items?.length) setCurations(items);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <main className="min-h-screen selection:bg-[#E5E0D8] selection:text-[#2C2A29] bg-[#FAF8F5] flex flex-col">
      <SEO
        title="CurateEd | Handpicked Premium Courses"
        description="Discover the best online courses for creative, tech, and freelance careers. Handpicked, data-driven curations."
        url={`${SITE_URL}/`}
        exactTitle
      />
      <Navigation />

      <div className="flex-1 max-w-6xl mx-auto px-6 sm:px-8 py-12 md:py-20 w-full">
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <span className="inline-block px-3 py-1 mb-6 rounded-full border border-[#E5E0D8] bg-white text-xs font-medium tracking-wide text-[#8A847A] uppercase">
            Data-Driven Curation
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-[#2C2A29] leading-[1.15] mb-6">
            Handpicked courses for your next chapter.
          </h1>
          <p className="text-lg text-[#6B6661] leading-relaxed font-light px-4">
            We analyze thousands of student reviews to bring you the most aesthetic, high-quality,
            and actionable online courses.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {loading && curations.length === 0
            ? [0, 1, 2, 3, 4, 5].map((item) => <CurationCardSkeleton key={item} />)
            : curations.map((curation, index) => (
                <CurationCard
                  key={curation.id}
                  curation={curation}
                  index={index}
                  priority={index === 0}
                />
              ))}
        </div>
      </div>

      <Footer />
    </main>
  );
}